import { z } from 'zod';

import { commentMaxLength, formFieldNames } from './AddCommentPopupContent.constants';

export const schema = z.object({
    [formFieldNames.comment]: z.string().trim().max(commentMaxLength),
});
